import React from 'react';

import ReplyToEmail from 'modules/Unregistered/containers/ReplyToEmail';

export const ReplyToEmailCandidatesPage = () => (
	<div>
		<ReplyToEmail />
	</div>
);
